import { inputVariants } from '@/components/ui/Input';
import { XStack, YStack } from '@/components/ui/layout/layout';

import { SlugChip } from './badges';
import { FieldLabel } from './field-label';

export function NameSlugField({
  name,
  slug,
  onNameChange,
}: {
  name: string;
  slug: string;
  onNameChange: (v: string) => void;
}) {
  return (
    <YStack className="gap-2">
      <XStack className="items-center justify-between">
        <FieldLabel>Name</FieldLabel>
        <span className="font-mono text-[10px] text-foreground-muted">
          {name.length}/64
        </span>
      </XStack>
      <input
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        maxLength={64}
        spellCheck={false}
        placeholder="Memory"
        className={inputVariants()}
      />
      <XStack className="items-center gap-2">
        <span className="text-xs text-foreground-muted">Slug</span>
        <SlugChip className={slug ? undefined : 'text-foreground-muted'}>
          {slug || 'your-server-name'}
        </SlugChip>
        <span className="text-[10px] text-foreground-muted">
          read-only · a–z 0–9 - _
        </span>
      </XStack>
    </YStack>
  );
}
